import React from "react";
import { FaInstagram, FaFacebook } from "react-icons/fa";

export default function FooterCliente({ empresa }) {
  // 🔹 Normaliza links (permite @usuario o URL completa)
  const normalizarInstagram = (valor) => {
    if (!valor) return null;
    if (valor.startsWith("http")) return valor;
    return `https://instagram.com/${valor.replace("@", "")}`;
  };

  const normalizarFacebook = (valor) => {
    if (!valor) return null;
    if (valor.startsWith("http")) return valor;
    return `https://facebook.com/${valor.replace("@", "")}`;
  };

  const instagramUrl = normalizarInstagram(empresa.instagram);
  const facebookUrl = normalizarFacebook(empresa.facebook);

  return (
    <footer className="bg-dark text-light text-center py-3 border-top mt-auto">
      <div className="container">
        <p className="mb-1">
          <strong>📍 Dirección:</strong> {empresa.direccion}
        </p>

        <p className="mb-2">
          <strong>📞 Teléfono:</strong>{" "}
          <a
            href={`tel:${empresa.telefono}`}
            className="text-warning text-decoration-none"
          >
            {empresa.telefono}
          </a>
        </p>

        {/* 🔹 Redes sociales */}
        {(instagramUrl || facebookUrl) && (
          <div className="d-flex justify-content-center gap-4 mb-2">
            {instagramUrl && (
              <a
                href={instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-light"
                style={{ fontSize: "1.8rem" }}
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
            )}

            {facebookUrl && (
              <a
                href={facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-light"
                style={{ fontSize: "1.8rem" }}
                aria-label="Facebook"
              >
                <FaFacebook />
              </a>
            )}
          </div>
        )}

        <small>
            Diseñado por{" "}
            <a
              href="https://negociosnetdash.netlify.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="fw-bold text-warning text-decoration-none"
            >
              NegociosNet
            </a>{" "}
            © {new Date().getFullYear()}
        </small>
      </div>
    </footer>
  );
}
